export default {
  SIGNUP_EARN_FETCHED: 'SIGNUP_EARN_FETCHED',
  SIGNUP_EARN_LOAD: 'SIGNUP_EARN_LOAD',
  SIGNUP_EARN_TEMPLATES_FETCHED: 'SIGNUP_EARN_TEMPLATES_FETCHED',
  SIGNUP_EARN_TEMPLATES_LOAD: 'SIGNUP_EARN_TEMPLATES_LOAD',
  SIGNUP_EARN_DETAIL: 'SIGNUP_EARN_DETAIL',
  SIGNUP_EARN_BUTTON_LOAD: 'SIGNUP_EARN_BUTTON_LOAD',
};
